import { render, staticRenderFns } from "./ContentDropdown.vue?vue&type=template&id=1f972282&scoped=true&"
import script from "./ContentDropdown.vue?vue&type=script&lang=js&"
export * from "./ContentDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ContentDropdown.vue?vue&type=style&index=0&id=1f972282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f972282",
  null
  
)

export default component.exports